import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SafeIcon from '../common/SafeIcon';
import AboutModal from './AboutModal';
import ServicesModal from './ServicesModal';
import ContactModal from './ContactModal';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiLogIn, FiUserPlus, FiGrid, FiLogOut } = FiIcons;

const Header = () => {
  const { user, signOut } = useAuth();
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeAll = () => setIsMenuOpen(false);

  return (
    <>
      <header className="bg-white/90 backdrop-blur-md border-b border-slate-200 sticky top-0 z-40 supports-[backdrop-filter]:bg-white/60">
        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 md:space-x-3 active:opacity-80 transition-opacity">
              <img src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/6eb52941ad96e193ea6fc16c1e36c535.png" alt="Chaldean Link Logo" className="h-8 w-auto md:h-9" />
              {/* Optional: Add text logo for better brand recognition on mobile if needed */}
              {/* <span className="font-bold text-slate-900 text-lg tracking-tight md:hidden">Chaldean Link</span> */}
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-slate-700">
              <button onClick={() => setShowAboutModal(true)} className="hover:text-slate-900 transition-colors">About</button>
              <button onClick={() => setShowServicesModal(true)} className="hover:text-slate-900 transition-colors">Services</button>
              <button onClick={() => setShowContactModal(true)} className="hover:text-slate-900 transition-colors">Contact</button>
            </nav>

            <div className="flex items-center space-x-2">
              {/* Desktop Auth Buttons */}
              <div className="hidden md:flex items-center space-x-3">
                {user ? (
                  <>
                    <Link to="/dashboard" className="flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                      <SafeIcon icon={FiGrid} />
                      <span>Dashboard</span>
                    </Link>
                    <button onClick={signOut} className="flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                      <SafeIcon icon={FiLogOut} />
                      <span>Sign Out</span>
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                      <SafeIcon icon={FiLogIn} />
                      <span>Login</span>
                    </Link>
                    <Link to="/signup" className="flex items-center space-x-2 bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-slate-800 transition-colors">
                      <SafeIcon icon={FiUserPlus} />
                      <span>Sign Up</span>
                    </Link>
                  </>
                )}
              </div>

              {/* Mobile Menu Button - Simplified */}
              <div className="md:hidden">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="p-2 -mr-2 text-slate-600 hover:text-slate-900 active:bg-slate-100 rounded-full transition-colors"
                  aria-label="Toggle menu"
                >
                  <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Slide-down Menu */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-white border-t border-slate-200 overflow-hidden"
            >
              <div className="flex flex-col p-4 space-y-1">
                <div className="grid grid-cols-2 gap-3 mb-4">
                  <button
                    onClick={() => { setShowAboutModal(true); closeAll(); }}
                    className="p-3 text-center bg-slate-50 rounded-xl text-sm font-medium text-slate-700 active:bg-slate-200"
                  >
                    About Us
                  </button>
                  <button
                    onClick={() => { setShowServicesModal(true); closeAll(); }}
                    className="p-3 text-center bg-slate-50 rounded-xl text-sm font-medium text-slate-700 active:bg-slate-200"
                  >
                    Services
                  </button>
                  <button
                    onClick={() => { setShowContactModal(true); closeAll(); }}
                    className="col-span-2 p-3 text-center bg-slate-50 rounded-xl text-sm font-medium text-slate-700 active:bg-slate-200"
                  >
                    Contact Support
                  </button>
                </div>

                {user && (
                  <button
                    onClick={() => { signOut(); closeAll(); }}
                    className="flex items-center justify-center space-x-2 w-full p-3 text-red-600 bg-red-50 rounded-xl font-medium active:bg-red-100"
                  >
                    <SafeIcon icon={FiLogOut} />
                    <span>Sign Out</span>
                  </button>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
      <AboutModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} />
      <ServicesModal isOpen={showServicesModal} onClose={() => setShowServicesModal(false)} />
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
    </>
  );
};

export default Header;